<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.firstName ? values.firstName : "-" }}
              {{ values.fatherName ? values.fatherName : "-" }}
              {{ values.grandFatherName ? values.grandFatherName : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Sex:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.sex ? values.sex : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Date of Birth:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.dateOfBirth ? values.dateOfBirth : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Id-No:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.idNo ? values.idNo : "-" }}
            </p>
          </div>
        </div>
      </v-card-text>

      <div class="title" style="background-color: #f3f3f3; padding: 5px 24px;">
        About University
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Higher Learning Institution:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.university.name
                    ? values.university.name
                    : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Ownership:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.university.ownership.name ? values.university.ownership.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Generation Level:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.university.generation ? values.university.generation : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Region:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.university.region.name ? values.university.region.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Town:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.university.town ? values.university.town : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <!-- <p class="text-md-left font-weight-bold">Is Withdrawn?</p> -->
          </div>
          <div class="w-1/2 h-12">
            <!-- <div class=".text-base">
              <span style="float: left">
                <v-chip :color="getColor(values.isWithdrawn)" dark>
                  {{ values.isWithdrawn }}
                </v-chip>
              </span>
            </div> -->
          </div>
        </div>
      </v-card-text>

      <div class="title" style="background-color: #f3f3f3; padding: 5px 24px;">
        Educational Information
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Education Program:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.educationProgram ? values.educationProgram.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Discipline:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.discipline ? values.discipline.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Level Of Study:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.levelOfStudy ? values.levelOfStudy.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year Of Entry:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.entryYear ? values.entryYear : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Proposed Year of Graduation:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.expectedYear
                    ? values.expectedYear
                    : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year of Graduation:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.graduationYear ? values.graduationYear : "-" }}
            </p>
          </div>
        </div>

        <v-card
            class="flex flex-wrap my-2 mb-6"
            outlined
            style="background-color: whitesmoke"
        >
          <div class="w-full pb-0 md:mb-0">
            <v-simple-table :light="dataTableLight">
              <template
                  v-if="values?.pre_student_statuses.length === 0"
                  v-slot:no-data
              >
                NO DATA TO DISPLAY
              </template>
              <template v-else v-slot:default>
                <thead style="background-color: #e9ecee;">
                <tr>
                  <th width="5%">#</th>
                  <th class="text-left" width="10%">
                    Year of Education
                  </th>
                  <th class="text-left" width="10%">
                    Student Status
                  </th>
                  <th class="text-left" width="10%">
                    GPA
                  </th>
                  <!-- <th width="10%" class="text-left">
                    Discipline
                  </th> -->
                </tr>
                </thead>
                <tbody style="background-color: whitesmoke;">
                <tr
                    v-for="(item, index) in values.pre_student_statuses"
                    :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <span>{{ item.yearOfEducation }}</span>
                  </td>
                  <td>
                    <span>{{ item.studentStatus }}</span>
                  </td>
                  <td>
                    <span>{{ item.gpa }}</span>
                  </td>
                  <!-- <td>
                    <span>{{ item.discipline }}</span>
                  </td> -->
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    graduates: Object,
  },
  data() {
    return {
      values: [],
      dataTableLight: true,
    };
  },
  created() {
    if (this.graduates != null) {
      this.values = this.graduates;
    }
  },
  methods: {
    getColor(isActive) {
      if (isActive == "No") return "red";
      else return "green";
    },
  },
};
</script>
